import ApiCore from './utilities/core'
import apiProvider from './utilities/provider'

const url = 'talent-pools'

const apiTalentPool = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  delete: false,
  url,
})

apiTalentPool.getByInvitationLink = (invitationLink) =>
  apiProvider.getAll(`${url}/external/${invitationLink}/candidates`)

apiTalentPool.applyToTalentPool = (invitationLink, data) =>
  apiProvider.post(`${url}/external/${invitationLink}/apply`, data)

apiTalentPool.trackExternalLinkClick = (invitationLink, linkData) =>
  apiProvider.post(`${url}/external/${invitationLink}/track-link`, {
    linkType: linkData.linkType,
    url: linkData.url,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
  })

apiTalentPool.shareLink = (invitationLink, shareData) =>
  apiProvider.post(`${url}/external/${invitationLink}/share`, {
    platform: shareData.platform,
    timestamp: new Date().toISOString(),
  })

apiTalentPool.getSocialMediaLinks = (invitationLink) =>
  apiProvider.getAll(`${url}/external/${invitationLink}/social-media`)

apiTalentPool.getExternalResources = (invitationLink) =>
  apiProvider.getAll(`${url}/external/${invitationLink}/external-resources`)

export default apiTalentPool
